import { CustomSignIn } from '@/components/auth/custom-sign-in';
import { PartnerOtpSignIn } from '@/components/auth/partner-otp-sign-in';
import { resolveSatellite } from '@/config/clerk-satellite';

/**
 * Sign-in entry point. Three cases:
 *
 *  1. Primary host (`app.tagada.io`) → render <CustomSignIn /> (Clerk
 *     OTP + Google, sign-in creation allowed here).
 *
 *  2. Partner whitelabel satellite (e.g. `app.tagadapartnerdemo.app`,
 *     where `resolveSatellite()` returns a partner config) → render
 *     <PartnerOtpSignIn />. The whole email + OTP flow stays on the
 *     partner domain: we drive a self-owned OTP against our backend,
 *     get a Clerk sign-in token back, and hand it to the primary's
 *     `/accept-sign-in` bridge for a near-invisible flash. The user
 *     never types credentials on the primary.
 *
 *     This replaces the previous behaviour of bouncing the partner user
 *     to `app.tagada.io/sign-in` (where they saw the primary host while
 *     typing). The bounce was only ever needed because Clerk rejects
 *     sign-in CREATION on satellites — the token-handoff sidesteps that.
 */
export default function SignInPage() {
  const satellite = resolveSatellite();

  if (satellite) {
    return <PartnerOtpSignIn />;
  }

  return <CustomSignIn />;
}
